module.exports = __webpack_public_path__ + "assets/img/fl.0b5c1bce.svg";